import { c as _c } from "react/compiler-runtime";
import Button from '@precis-digital/kurama/Button';
import Grid from '@precis-digital/kurama/Grid';
import RightIcon from '@precis-digital/kurama/icons/RightIcon';
import Typography from '@precis-digital/kurama/Typography';
import { useTheme } from '@precis-digital/kurama/utils';
import React, { forwardRef, useCallback, useMemo } from 'react';
import { APP_ROUTES } from 'shared/routes';
import { useTranslation } from 'shared/translations';
import { isNilOrEmpty } from 'shared/utils';
import HappyEmptyState from 'src/recommendations/components/HappyEmptyState';
import RecommendationsHomeFrame from 'src/recommendations/components/RecommendationsHomeFrame';
import { useFeedHomeCards, useRecommendationPopupDetails } from 'src/recommendations/hooks';
import { type GroupedRecommendationItem } from 'src/recommendations/types';
const RecommendationsV2 = forwardRef<HTMLDivElement>(function Frame(ref) {
  const $ = _c(34);
  const theme = useTheme();
  const {
    t
  } = useTranslation("recommendation");
  const {
    isPending,
    isError,
    noDataSources,
    isSuccess,
    allData
  } = useFeedHomeCards();
  let t0;
  if ($[0] !== allData) {
    t0 = {
      groupedRecommendations: allData
    };
    $[0] = allData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    showPopup,
    shouldShowPopup
  } = useRecommendationPopupDetails(t0);
  let t1;
  if ($[2] !== showPopup) {
    t1 = recommendation => {
      showPopup(recommendation);
    };
    $[2] = showPopup;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleRecommendationClick = t1;
  let t2;
  if ($[4] !== handleRecommendationClick) {
    t2 = {
      onRecommendationClick: handleRecommendationClick
    };
    $[4] = handleRecommendationClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    cards
  } = useFeedHomeCards(t2);
  if (isSuccess && shouldShowPopup()) {
    showPopup();
  }
  let t3;
  bb0: {
    if (isPending || isError) {
      t3 = null;
      break bb0;
    }
    if (noDataSources) {
      let t4;
      if ($[6] !== theme) {
        t4 = theme.spacing(3);
        $[6] = theme;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      let t5;
      if ($[8] !== t) {
        t5 = t("noRecommendations.noDataSources.title");
        $[8] = t;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      let t6;
      if ($[10] !== t5) {
        t6 = <Grid item={true} xs={8}><Typography variant="h4">{t5}</Typography></Grid>;
        $[10] = t5;
        $[11] = t6;
      } else {
        t6 = $[11];
      }
      let t7;
      if ($[12] !== t) {
        t7 = t("noRecommendations.noDataSources.description");
        $[12] = t;
        $[13] = t7;
      } else {
        t7 = $[13];
      }
      let t8;
      if ($[14] !== t7) {
        t8 = <Grid item={true} xs={8}><Typography variant="body2">{t7}</Typography></Grid>;
        $[14] = t7;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      let t9;
      if ($[16] !== theme) {
        t9 = theme.spacing(2);
        $[16] = theme;
        $[17] = t9;
      } else {
        t9 = $[17];
      }
      let t10;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <RightIcon />;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      let t11;
      if ($[19] !== t) {
        t11 = t("addADataSource");
        $[19] = t;
        $[20] = t11;
      } else {
        t11 = $[20];
      }
      let t12;
      if ($[21] !== t11) {
        t12 = <Button rightIcon={t10} variant="filled" href={APP_ROUTES.dataSources.basePage}>{t11}</Button>;
        $[21] = t11;
        $[22] = t12;
      } else {
        t12 = $[22];
      }
      let t13;
      if ($[23] !== t12 || $[24] !== t9) {
        t13 = <Grid item={true} xs={10} marginTop={t9}>{t12}</Grid>;
        $[23] = t12;
        $[24] = t9;
        $[25] = t13;
      } else {
        t13 = $[25];
      }
      let t14;
      if ($[26] !== t13 || $[27] !== t4 || $[28] !== t6 || $[29] !== t8) {
        t14 = <Grid container={true} gap={t4} justifyContent="center">{t6}{t8}{t13}</Grid>;
        $[26] = t13;
        $[27] = t4;
        $[28] = t6;
        $[29] = t8;
        $[30] = t14;
      } else {
        t14 = $[30];
      }
      t3 = t14;
      break bb0;
    }
    if (isNilOrEmpty(cards)) {
      let t4;
      if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <HappyEmptyState />;
        $[31] = t4;
      } else {
        t4 = $[31];
      }
      t3 = t4;
      break bb0;
    }
    t3 = cards;
  }
  const content = t3;
  let t4;
  if ($[32] !== content) {
    t4 = <RecommendationsHomeFrame content={content} />;
    $[32] = content;
    $[33] = t4;
  } else {
    t4 = $[33];
  }
  return t4;
});
export default RecommendationsV2;